import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { Route, Routes, useLocation } from "react-router-dom";
import LandingHeader from "views/lysto/LandingPage/LandingHeader";

function LandingContent(props) {
  const location = useLocation();

  // Only show the LandingHeader on the main landing page, not for legal pages
  const isLegalPage =
    location.pathname.includes("/privacy") ||
    location.pathname.includes("/terms");

  // Scroll to the top when on legal pages
  useEffect(() => {
    if (isLegalPage) {
      window.scrollTo(0, 0);
    }
  }, [isLegalPage]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      const isIndex = prop.path === "";
      return (
        <Route
          key={key}
          index={isIndex}
          path={isIndex ? undefined : prop.path}
          element={<prop.component {...props} />}
        />
      );
    });
  };

  return (
    <>
      {/* Header outside of any container - only for main landing page */}
      {!isLegalPage && <LandingHeader />}

      {/* Main content - with minimal padding to avoid double spacing */}
      <Box
        as="main"
        pt="0" // Remove extra padding, we're accounting for it in individual components
        w="100%"
        marginTop={!isLegalPage ? "70px" : "0"} // Space for the fixed header using margin instead, only if header is shown
      >
        <Routes>{getRoutes(props.routes)}</Routes>
      </Box>
    </>
  );
}

export default function LandingLayout(props) {
  // Return the content directly without additional Box wrapper
  return <LandingContent {...props} />;
}
